import { IBannerItem } from 'entities/banner/types';

export const useUpdateBannerCardDefaultValues = (data: IBannerItem) => {
  if (!data) {
    return {};
  }

  return {
    ...data,
  };
};
